import { useEffect, useState } from "react";
import { supabase } from "./supabase";

// Fotos de paquetes: el bucket es privado, se muestran con enlaces firmados que expiran.
const cache = {};

export function rutaFoto(p) {
  if (!p) return null;
  const m = String(p).match(/fotos-paquetes\/(.+?)(\?|$)/);
  return m ? decodeURIComponent(m[1]) : String(p);
}

async function firmar(path) {
  const hit = cache[path];
  if (hit && hit.exp > Date.now()) return hit.url;
  const { data } = await supabase.storage.from("fotos-paquetes").createSignedUrl(path, 3600);
  if (!data?.signedUrl) return null;
  cache[path] = { url: data.signedUrl, exp: Date.now() + 50 * 60 * 1000 };
  return data.signedUrl;
}

export default function SignedImg({ path, alt = "", ...rest }) {
  const ruta = rutaFoto(path);
  const [url, setUrl] = useState(ruta && cache[ruta] && cache[ruta].exp > Date.now() ? cache[ruta].url : null);
  const [fallo, setFallo] = useState(false);
  useEffect(() => {
    let vivo = true;
    setFallo(false);
    if (!ruta) { setUrl(null); return; }
    firmar(ruta).then(u => { if (!vivo) return; if (u) setUrl(u); else setFallo(true); });
    return () => { vivo = false; };
  }, [ruta]);
  if (fallo) return <div style={{ ...(rest.style || {}), display:"flex", alignItems:"center", justifyContent:"center", minHeight:80, fontSize:12, opacity:.6 }}>No disponible</div>;
  if (!url) return <div style={{ ...(rest.style || {}), minHeight:80, background:"rgba(255,255,255,0.04)" }} />;
  return <img src={url} alt={alt} {...rest} />;
}
